<template>
  <div class="schoolprofile">
    <div class="content">
      <h1>
        我的课程
        <span class="sort" v-if="!pilotCourseShow" :class="{ 'sort-active': sortplan }" @click="sortshow(true)">
          <i class="iconfont icon-zonghepaixu"></i>
          按学期排序
        </span>
        <span class="sort" v-if="!pilotCourseShow" :class="{ 'sort-active': !sortplan }" @click="sortshow(false)">
          <i class="iconfont icon-zonghepaixu"></i>
          按学情排序
        </span>
        <span v-if="pilotCourseShow" style="margin-left: 20px; font-size: 14px; cursor: pointer" @click="handlePilotImg">
          <img src="@/assets/images/xdt.png" style="height: 22px; width: 22px" alt="" />
          先导图
        </span>
      </h1>
      <div class="clearfix"></div>
      <div class="divTab">
        <!-- 学期列表 -->
        <div class="nav-tab">
          <div v-if="sortplan && termSet && !pilotCourseShow">
            <div
              class="pointer"
              v-for="(item, index) in termSet"
              :key="index"
              :class="{ active: item.layoutTermOrder == selectedTab }"
              @click="changeTab(item.layoutTermOrder)"
            >
              <!-- 第{{ common.judgeNumberIndexIndex(item.layoutTermOrder) }}学期 -->
              {{ item.layoutTermDesc }}
            </div>
          </div>
          <ul class="coursetab" v-else-if="pilotCourseShow">
            <li
              v-for="(tab, index) in pilotCoursetabsData"
              :key="index"
              :class="{ active: tab == selectPilotCourseTabs }"
              @click="changePilotCourseTab(tab)"
              class="btn"
            >
              {{ tab }}
            </li>
          </ul>
          <ul class="coursetab" v-else>
            <li v-for="(tab, index) in tabs" :key="index" :class="{ active: index == selectedTabs }" @click="changeTabs(index)" class="btn">
              {{ tab }}
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>

        <a-spin :spinning="courseSpinning">
          <div class="tabs">
            <div v-if="dataCourse.length !== 0">
              <draggable class="row" v-model="dataCourse" @end="onEnd">
                <div class="col-md-4" v-for="item in dataCourse" :key="item.id">
                  <div class="course">
                    <!-- 课程封面及成绩信息 -->
                    <div class="row">
                      <!-- 课程封面 -->
                      <div class="col-md-6">
                        <div :class="$store.state.homeObj.credit_bank_show == '1' ? 'course-img-h120' : 'course-img-h100'">
                          <div class="qualified" v-if="item.practicalType && item.practicalType !== 2">
                            <span style="position: absolute; top: 5px; left: 5px; color: #ffffff">社会实践</span>
                            <img src="@/assets/images/sjk.png" style="height: 27px; width: 85px" alt="" />
                          </div>
                          <img :src="item.cover === '' ? `/static/images/defaultCourse.jpg` : item.cover" width="176" height="100" />
                        </div>
                      </div>
                      <!-- 课程信息 -->
                      <div class="col-md-6">
                        <div class="qualified">
                          <img v-if="item.pass === 1" src="../../../assets/images/hg.png" />
                          <!--合格水印-->
                        </div>
                        <template v-if="!item.practicalType && item.courseType.indexOf('论文') === -1">
                          <div class="qualified">
                            <img v-if="item.state === 2" src="@/assets/images/jsz.png" />
                            <!--建设中水印-->
                            <img v-if="item.state === 3" src="@/assets/images/wqy.png" />
                            <!--未启用水印-->
                          </div>
                        </template>
                        <div class="course-detail course-title ellipsis-2">
                          {{ item.viewName }}
                        </div>
                        <div class="course-detail course-num">代码：{{ item.viewCode }}</div>
                        <div class="course-detail course-style">课程类型：{{ item.courseType }}</div>
                        <div v-if="$store.state.homeObj.credit_bank_show == '1'" class="course-detail">
                          学分：{{ item.lessonPeriod }}
                          <span v-if="item.isCharge == 1" :style="{ color: '#ff0000', fontSize: '12px' }">兑</span>
                        </div>

                        <!-- 课程成绩 -->
                        <div class="course-detail">
                          <template v-if="$store.state.homeObj.score_button_text != ''">{{ $store.state.homeObj.score_button_text }}:</template>
                          <template v-else>成绩：</template>
                          <span v-if="isLoginByInter !== '1'" @click="checkDetail(item)">
                            <span
                              class="course-score"
                              :style="
                                homeObj.no_fee_score_show == 0 && !item.subjectFeeFlag
                                  ? 'font-size:13px;color:red!important;text-decoration: underline;font-weight: 400;cursor: pointer;'
                                  : ''
                              "
                            >
                              {{ item.scoreText }}
                            </span>
                            <a v-if="$store.state.homeObj.show_score_detail === '1'">&nbsp;查看详情</a>
                          </span>
                          <template v-else>
                            <span class="course-score">{{ item.scoreText }}</span>
                          </template>
                        </div>
                        <div v-if="item.courseType == '毕业论文' && isShowThesis">
                          <a-button class="course-btn active" style="color: #fff" @click="openThesis">进入论文</a-button>
                        </div>
                      </div>
                    </div>

                    <!-- 课程学习 -->
                    <div class="buttons">
                      <div v-if="item.viewCode !== '013200'">
                        <div class="row" v-if="item.state === 1">
                          <template v-if="(!item.practicalType || item.practicalType == 2) && item.courseType.indexOf('论文') === -1">
                            <!--开始/线下学习-->
                            <div class="col-md-4" v-if="$store.state.homeObj.study_button_show != '1'">
                              <div v-if="item.webLearnFlag === 1">
                                <button
                                  :style="homeObj.is_study_exam_state == '1' && !item.isStudyTime ? 'background: #ccd1cf;' : ''"
                                  class="course-btn active"
                                  @click.stop="startStudy(item.layoutTermOrder, item.studyStart, item.studyEnd, item.viewCode, item.isStudyTime)"
                                >
                                  开始学习
                                </button>
                              </div>
                              <div v-if="item.webLearnFlag === 0">
                                <button class="course-btn active" @click.stop="unOnlineStudy">线下学习</button>
                              </div>
                            </div>
                            <!--在线/线下考试-->
                            <div class="col-md-4">
                              <div v-if="item.webTestFlag === 1">
                                <button
                                  :style="homeObj.is_study_exam_state == '1' && !item.isExamTime ? 'background: #ccd1cf;' : ''"
                                  class="course-btn active"
                                  @click.stop="startExam(item.layoutTermOrder, item.viewCode, '', item.isExamTime)"
                                >
                                  <template v-if="$store.state.homeObj.exam_button_text !== ''">
                                    {{ $store.state.homeObj.exam_button_text }}
                                  </template>
                                  <template v-else>在线考试</template>
                                </button>
                              </div>
                              <div v-if="item.webTestFlag === 0">
                                <button class="course-btn active" @click.stop="unOnlineExam">线下考试</button>
                              </div>
                            </div>
                            <!--考试记录-->
                            <div class="col-md-4" @click.stop="notExamList(item)" v-if="isLoginByInter !== '1'">
                              <button class="course-btn active">
                                <template v-if="$store.state.homeObj.examrecord_button_text !== ''">
                                  {{ $store.state.homeObj.examrecord_button_text }}
                                </template>
                                <template v-else>考试记录</template>
                              </button>
                            </div>
                          </template>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row">
                          <div class="col-md-6">
                            <button
                              class="course-btn-large"
                              @click="gotoDissertation"
                              :class="{ active: judgeDate(item.studyStart, item.studyEnd, CurrentTime) }"
                            >
                              进入论文管理
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 网络学习课程 -->
                    <template v-if="$store.state.homeObj.study_button_show != '1' && item.webLearnFlag === 1">
                      <div class="examinationtime" v-if="item.studyStart && item.studyEnd">
                        <div class="examinationtime">
                          <div class="largrshow">学习时间:</div>
                          {{ item.studyStart }}
                          <span class="margin-left-10">至</span>
                          <span class="margin-left-10"></span>
                          {{ item.studyEnd }}
                        </div>
                      </div>
                      <div v-else class="examinationtime">
                        <span class="largrshow">学习时间:</span>
                        暂未开始学习
                      </div>
                    </template>
                    <!-- 网络考试课程 -->
                    <template v-if="item.webTestFlag === 1">
                      <div class="examinationtime" v-if="item.viewCode !== '013200' && item.examStart && item.examEnd">
                        <div class="margin-top-10">
                          <div class="largrshow">考试时间:</div>
                          {{ item.examStart }}
                          <span class="margin-left-10">至</span>
                          <span class="margin-left-10"></span>
                          {{ item.examEnd }}
                        </div>
                      </div>
                      <div v-else class="examinationtime margin-top-10">
                        <span class="largrshow">考试时间:</span>
                        暂未开始考试
                      </div>
                    </template>

                    <!-- 实践课 -->
                    <template v-if="item.practicalType && item.configFlag">
                      <div v-if="$store.state.homeObj.study_button_show != '1' && item.studyStart && item.studyEnd">
                        <button class="course-btn active" style="margin-bottom: 2px" @click="goToDetail(item)">
                          {{ item.practicalType == 2 ? '上传资料' : '进入课程' }}
                        </button>
                      </div>
                    </template>
                  </div>
                </div>
              </draggable>
            </div>
            <div v-else>
              <a-empty :description="'暂无课程'" />
            </div>
          </div>
        </a-spin>
      </div>
    </div>
    <a-modal :title="title" :visible="detailShowFlag" @cancel="handleCancel" :footer="null" :width="1000">
      <grade-info
        :currentDetail="currentDetail"
        :currentScore="currentScore"
        :currentUpdateTime="currentUpdateTime"
        :isEdit="isEdit"
        :scoreId="scoreId"
        @freshScore="getfreshScore"
        @getDeatilAllValue="getDeatilAllValue"
      />
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" :width="1000" @cancel="handlePreviewCancel">
      <img title="点击查看大图" style="width: 100%" :src="pilotImg" @click="handlePreviewPng" />
    </a-modal>
    <selectExamMode :examMode.sync="showSelectExamModal" :examData.sync="examData"></selectExamMode>
  </div>
</template>
<script>
import { imageIsExist } from '@/utils/util';
import { mapState } from 'vuex';
import gradeInfo from '@/pages/myscore/components/gradeInfo';
import { simpleDebounce } from '../components/simpleDebounce';
import selectExamMode from './modal/SelectExamMode.vue';
import draggable from 'vuedraggable';

export default {
  name: 'CoursePlan',
  components: { gradeInfo, draggable, selectExamMode },
  props: {
    course: Array,
    termSet: Array,
    CurrentTime: Number,
  },
  data: function() {
    return {
      tab: [
        {
          title: '第一学期',
          content: 'this is tab1',
          isactive: true,
        },
        {
          title: '第二学期',
          content: 'this is tab2',
          isactive: false,
        },
      ],
      selectedTab: 1,
      tabs: ['待学', '在学', '已学', '全部'],
      selectedTabs: 3,
      tabsCon: ['内容1', '内容2', '内容3'],
      dataCourse: [],
      num: 0,
      sortplan: true,
      courseSpinning: true,
      delayTime: 300,
      unpaidTuitionFlag: '',
      isLoginByInter: '',
      detailShowFlag: false,
      currentDetail: null,
      title: '成绩详情',
      currentScore: null,
      currentUpdateTime: null,
      scoreId: '',
      isEdit: 0,
      isShowThesis: false,
      pilotCourseShow: false, // 先导课模式
      pilotCourseData: null,
      pilotCourseDataList: [],
      pilotCoursetabsData: null,
      selectPilotCourseTabs: '在学',
      pilotImg: '',
      previewVisible: false,
      showSelectExamModal: false,
      subjectFeeFlag: null,
      examData: {
        viewCode: null,
        examMode: null,
      },
    };
  },
  created() {
    this.isLoginByInter = localStorage.getItem('isLoginByInter');
    this.sortplan = this.common.getStorage('sortplan', true);
    this.sortplan = true;
    this.axios.get('/biz/thesis/getUserInfo').then(res => {
      if (res.result.length > 0) {
        this.isShowThesis = true;
      }
    });
  },
  mounted() {
    this.selectedTab = this.termSet[0].layoutTermOrder;
    // 初次通过props传入course的时候不会触发监听，所以通过调用函数的方式做一些筛选操作
    this.initCourse();
    this.getPilotCourseShow();
  },
  computed: {
    ...mapState(['userInfo', 'homeObj']),
  },
  methods: {
    /**
     * 实践课点击事件
     */
    goToDetail(item) {
      if (item.practicalType && item.configFlag) {
        this.$router.push(`/practicedetail?id=${item.planId}&pt=${item.practicalType}`);
      }
    },

    /**
     * 查询先导课程展示配置
     */
    getPilotCourseShow() {
      const params = {
        eduCode: this.userInfo.eduCode,
        paramKey: 'course_mode',
      };
      this.axios.get('/student/departParam/all', { params }).then(res => {
        this.pilotCourseShow = res.result[0].paramVal == 2;
        if (res.result[0].paramVal == 2) {
          this.getPilotCourseList();
          this.getPilotImg();
        }
      });
    },

    /**
     * 查询先导课程列表
     */
    getPilotCourseList() {
      this.axios.get('/biz/subject/getMyPreviewSubject').then(res => {
        if (res.code === 200) {
          this.pilotCourseData = res.result;
          this.pilotCoursetabsData = Object.keys(res.result);
          this.dataCourse = res.result[this.selectPilotCourseTabs] || [];
        }
      });
    },

    /**
     * 先导课程切换事件
     */
    changePilotCourseTab(index) {
      this.selectPilotCourseTabs = index;
      this.dataCourse = this.pilotCourseData[this.selectPilotCourseTabs] || [];
    },
    getPilotImg() {
      this.axios.get('/student/eduProfession/getMyPro').then(res => {
        if (res.code === 200) {
          this.pilotImg = res.result.frontSubjectImage;
        }
      });
    },

    handlePilotImg() {
      this.previewVisible = true;
    },

    handlePreviewPng() {
      window.open(this.pilotImg);
    },

    change(index) {
      this.tab.forEach(function(v) {
        v.isactive = false;
      });
      this.tab[index].isactive = true;
    },

    handleCancel() {
      this.detailShowFlag = false;
    },
    handlePreviewCancel() {
      this.previewVisible = false;
    },

    getfreshScore(msg) {
      setTimeout(() => {
        this.getScoreDetail(msg.scoreId, msg.isShow);
      }, 500);
    },

    /**
     * 判断字符串 是数字转换成数值类型 否则数据类型不变
     * @param str
     */
    convertStringToNumber(str) {
      let num = Number(str);
      if (!isNaN(num)) {
        return num;
      } else {
        return str;
      }
    },

    getDeatilAllValue: simpleDebounce(function(id) {
      this.axios
        .get(`/biz/score/info`, {
          params: { score_id: id, token: this.common.getStorage('token') },
        })
        .then(res => {
          let data = res.result;
          let gradeData = {};
          data.forEach(item => {
            if (item.pid && item.pid !== '0') {
              // 判断该项是否是子项, 是子项，将其加入到childList
              if (!gradeData[item.pid]) {
                gradeData[item.pid] = {};
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              } else {
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              }
            } else if (item.pid === '0') {
              // 非子项，将其放入parent属性
              if (!gradeData[item.id]) {
                gradeData[item.id] = {};
                gradeData[item.id].parent = item;
              } else {
                gradeData[item.id].parent = item;
              }
            }
          });
          this.currentDetail = gradeData;
        });

      this.axios.get('/biz/score/mine').then(res => {
        if (res.success && res.result) {
          res.result.forEach(res => {
            if (res.id === id) {
              this.currentScore = this.convertStringToNumber(res.scoreStr);
              this.$message.success('刷新成功!');
            }
          });
        }
      });
    }, 500),

    /**
     * 查询成绩详情
     */
    getScoreDetail(id, isShow) {
      this.axios
        .get(`/biz/score/info`, {
          params: { score_id: id, token: this.common.getStorage('token') },
        })
        .then(res => {
          let data = res.result;
          let gradeData = {};
          data.forEach(item => {
            if (item.pid && item.pid !== '0') {
              // 判断该项是否是子项，是子项，将其加入到childList
              if (!gradeData[item.pid]) {
                gradeData[item.pid] = {};
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              } else {
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              }
            } else if (item.pid === '0') {
              // 非子项，将其放入parent属性
              if (!gradeData[item.id]) {
                gradeData[item.id] = {};
                gradeData[item.id].parent = item;
              } else {
                gradeData[item.id].parent = item;
              }
            }
          });
          this.currentDetail = gradeData;
          this.detailShowFlag = isShow;
        });
    },

    /**
     * 课程成绩点击事件
     * @param item
     */
    checkDetail(item) {
      if (this.homeObj.no_fee_score_show == 0) {
        if (item.subjectFeeFlag) {
          if (this.$store.state.homeObj.show_score_detail == 1) {
            this.title = `《${item.viewName}》成绩详情`;
            this.currentScore = item.score;
            this.scoreId = item.scoreId;
            this.getScoreDetail(item.scoreId, true);
          }
        } else {
          this.$router.push('/personalcenters/payment');
        }
      } else {
        if (this.$store.state.homeObj.show_score_detail == 1) {
          this.title = `《${item.viewName}》成绩详情`;
          this.currentScore = item.score;
          this.scoreId = item.scoreId;
          this.getScoreDetail(item.scoreId, true);
        }
      }
    },

    /**
     * 课程排序
     */
    sortshow(flag) {
      this.sortplan = flag;
      this.common.setStorage('sortplan', this.sortplan);
      this.initCourse();
    },

    /**
     * 切换学期
     */
    changeTab(index) {
      this.selectedTab = index;
    },

    // 筛选学习状态
    changeTabs(index) {
      this.selectedTabs = index;
    },

    table(index) {
      this.num = index;
    },

    gotoDissertation() {
      this.$router.push('/graduationManagement');
    },

    onEnd(event) {
      console.log('拖拽结束', event);
    },

    /**
     * 开始学习点击事件
     * @param layoutTermOrder 学期
     * @param start 开始时间
     * @param end 结束时间
     * @param viewCode 课程编码
     * @param type 是否在学习时间内 1：在学习时间内 0：不在学习时间内
     */
    startStudy(layoutTermOrder, start, end, viewCode, type) {
      if (this.homeObj.is_study_exam_state == '1' && !type) {
        let errMsg = '';
        if (!start && !end && this.userInfo.eduCode == '125' && this.userInfo.grade == '2025' && layoutTermOrder == 3) {
          errMsg = '课程资源更新中...';
        } else {
          errMsg = '不在学习时间内，无法学习！';
        }
        const modal = this.$error({
          title: '温馨提示',
          icon: 'smile',
          content: errMsg,
          okButtonProps: {
            style: { background: '#2caf7a', border: `1px solid #2caf7a` },
          },
          onOk: () => {},
        });
        setTimeout(() => {
          modal.destroy(); // 销毁模态框实例
        }, 3000);
        return;
      }
      this.axios.get(`biz/subject/url?subjectCode=&viewCode=${viewCode}&chapterId=`).then(res => {
        if (res.code === 200 && res.result !== null) {
          window.open(res.result);
          return;
        }

        let messageTstring = JSON.parse(res.message);
        if (res.code === 200 && messageTstring.code === '9002') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '1000') {
          this.$message.error(messageTstring.msg);
          this.$router.push('/mypersonal/tuitionfeethis');
          return;
        } else if (res.code === 200 && messageTstring.code === '2202') {
          this.$message.error(messageTstring.msg);
          this.$router.push(`/personalcenters/payment`);
          return;
        } else if (res.code === 200 && messageTstring.code === '2201') {
          this.$message.error(messageTstring.msg);
          this.$router.push(`/personalcenters/payment`);
          return;
        } else if (res.code === 200 && messageTstring.code === '3000') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9000') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9999') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9001') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9004') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9005') {
          this.$message.error(messageTstring.msg);
          return;
        }
      });
    },

    /**
     * 线下学习点击事件
     */
    unOnlineStudy() {
      const modal = this.$error({
        title: '温馨提示',
        icon: 'smile',
        content: '线下学习课程！',
        okButtonProps: {
          style: { background: '#2caf7a', border: `1px solid #2caf7a` },
        },
        onOk: () => {},
      });
      setTimeout(() => {
        modal.destroy(); // 销毁模态框实例
      }, 3000);
      return;
    },

    /**
     * 线下考试点击事件
     */
    unOnlineExam() {
      const modal = this.$error({
        title: '温馨提示',
        icon: 'smile',
        content: '线下考试课程！',
        okButtonProps: {
          style: { background: '#2caf7a', border: `1px solid #2caf7a` },
        },
        onOk: () => {},
      });
      setTimeout(() => {
        modal.destroy(); // 销毁模态框实例
      }, 3000);
      return;
    },

    /**
     * 考试记录点击事件
     */
    async notExamList(item) {
      await this.axios.get(`/stu/stuUnpaid/mine`).then(res => {
        if (res.code === 200) {
          this.unpaidTuitionFlag = res.result;
        }
      });

      if (this.unpaidTuitionFlag === '2') {
        this.$message.warning('请先缴费');
        this.$router.push('/mypersonal/tuitionfeethis');
        return;
      }

      if (item.scoreText === '未缴费') {
        this.$message.error('未缴费不允许查看考试记录！');
        this.$router.push(`/personalcenters/payment`);
      } else {
        this.$router.push(`/examinationrecord?subjectId=${item.viewCode}`);
      }
    },

    /**
     * 在线考试点击事件
     * @param layoutTermOrder 学期
     * @param viewCode 课程编码
     * @param code
     * @param type 是否在考试时间内 1：在考试时间内 0：不在考试时间内
     */
    startExam(layoutTermOrder, viewCode, code, type) {
      this.examData.viewCode = viewCode;
      if (code != 1) {
        if (this.homeObj.is_study_exam_state == '1' && !type) {
          const modal = this.$error({
            title: '温馨提示',
            icon: 'smile',
            content: '不在考试时间内，无法考试！',
            okButtonProps: {
              style: { background: '#2caf7a', border: `1px solid #2caf7a` },
            },
            onOk: () => {},
          });
          setTimeout(() => {
            modal.destroy(); // 销毁模态框实例
          }, 3000);
          return;
        }
      }
      this.axios.get(`/biz/exam/url?subjectId=${viewCode}&chapterId=`).then(res => {
        if (res.code === 200 && res.result !== null) {
          if (code != 1) {
            this.axios.get(`/biz/exam/getExamMode?termOrder=${layoutTermOrder}`).then(res => {
              this.showSelectExamModal = true;
              this.examData.examMode = res.result.examMode;
              if (res.result.examMode == '2') {
                this.showSelectExamModal = true;
              }
            });
          } else {
            window.open(res.result);
          }
          return;
        }

        let messageTstring = JSON.parse(res.message);
        if (res.code === 200 && messageTstring.code === '1000') {
          this.$message.error(messageTstring.msg);
          this.$router.push('/mypersonal/tuitionfeethis');
          return;
        } else if (res.code === 200 && messageTstring.code === '2202') {
          this.$message.error(messageTstring.msg);
          this.$router.push(`/personalcenters/payment`);
          return;
        } else if (res.code === 200 && messageTstring.code === '2201') {
          this.$message.error(messageTstring.msg);
          this.$router.push(`/personalcenters/payment`);
          return;
        } else if (res.code === 200 && messageTstring.code === '3000') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9000') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9002') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9003') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9004') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9110') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9111') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9112') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9999') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9113') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9997') {
          this.$message.error(messageTstring.msg);
          return;
        } else if (res.code === 200 && messageTstring.code === '9998') {
          this.$message.error(messageTstring.msg);
          return;
        }
      });
    },

    /**
     * 判断当前时间是否在学习/考试时间内
     */
    judgeDate(start, end, current) {
      let startDate = this.common.format(start);
      let endDate = this.common.format(end);
      if (startDate < current && endDate > current) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 当通过props传入的course值不变化时，那么watch监听不会触发，无法筛选，所以使用initCourse()这个函数手动执行一次监听的内容实现初始化筛选操作
     */
    initCourse() {
      this.courseSpinning = true;
      setTimeout(() => {
        this.courseSpinning = false;
      }, this.delayTime);

      let data = [];
      if (this.sortplan) {
        this.course.forEach(item => {
          if (item.layoutTermOrder === this.selectedTab) {
            data.push(item);
          }
        });
      } else {
        this.course.forEach(item => {
          if (item.layoutStatus === this.selectedTabs || this.selectedTabs === 3) {
            data.push(item);
          }
        });
      }
      this.dataCourse = [];
      this.dataCourse = data;
    },

    /**
     * 论文点击事件
     */
    openThesis() {
      let userinfo = JSON.parse(localStorage.getItem('userInfo'));
      const thesisApi = process.env.thesisApi;
      this.axios.get(`${thesisApi}/eduThesisStuLogin/eduThesisStuLogin/getQuickToken?studentId=` + userinfo.id).then(res => {
        window.open(process.env.thesisUrl + '/quickLogin?uuid=' + res.result);
      });
    },
  },

  directives: {
    errimg: {
      // 指令的名称
      async bind(el, binding) {
        let imgURL = binding.value; // 获取图片地址
        if (!imgURL) return;
        if (!el.src) {
          el.setAttribute('src', imgURL);
        } else {
          let exist = await imageIsExist(el.src);
          if (!exist) {
            el.setAttribute('src', imgURL);
          }
        }
      },
    },
  },
  watch: {
    course: {
      handler: function(val, oldVal) {
        this.courseSpinning = true;
        setTimeout(() => {
          this.courseSpinning = false;
        }, this.delayTime);
        let data = [];
        val.forEach(item => {
          if (item.layoutTermOrder === this.selectedTab && (item.layoutStatus === this.selectedTabs || this.selectedTabs === 3)) {
            data.push(item);
          }
        });
        this.dataCourse = [];
        this.dataCourse = data;
      },
      deep: true,
    },
    selectedTab(val, oldVal) {
      this.courseSpinning = true;
      setTimeout(() => {
        this.courseSpinning = false;
      }, this.delayTime);
      let data = [];
      this.course.forEach(item => {
        if (item.layoutTermOrder === val) {
          data.push(item);
        }
      });
      this.dataCourse = [];
      this.dataCourse = data;
    },
    selectedTabs(val, oldVal) {
      this.courseSpinning = true;
      setTimeout(() => {
        this.courseSpinning = false;
      }, this.delayTime);
      let data = [];
      this.course.forEach(item => {
        if (item.layoutStatus === val || val === 3) {
          data.push(item);
        }
      });
      this.dataCourse = [];
      this.dataCourse = data;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.schoolprofile {
  .content {
    width: $pageWidth;
    margin: 0 auto;

    .choose {
      text-align: center;
    }

    h1 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 16px;

      .english {
        color: #999;
        font-size: 14px;
        font-weight: normal;
        text-transform: Uppercase;
      }
    }
  }

  .course {
    margin-bottom: 10px;
    padding: 20px;
    padding-right: 16px;
    padding-bottom: 14px;
    background: #f8fefc;
    width: 100%;

    &:hover {
      box-shadow: 0px 0px 10px #999;
    }

    a {
      color: #333;

      & .course-des {
        color: $fontGray;
      }
    }

    .course-img-h100 {
      img {
        width: 176px;
        height: 100px;
      }
    }

    .course-img-h120 {
      img {
        width: 176px;
        height: 120px;
      }
    }

    .course-title {
      font-size: 18px;
      line-height: 20px;
      height: 40px;
      font-weight: bold;
      color: #333;
      margin-bottom: 4px;
      position: relative;
    }

    .course-des {
      margin-top: 10px;
      line-height: 20px;
      color: #999;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .choose {
    width: 300px;
    margin: 0 auto;

    .btn {
      width: 90px;
      border: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.choose li {
  float: left;
}

.btn:focus, .btn.focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.more {
  font-size: 14px;
  font-weight: normal;

  &:hover {
    text-decoration: none;
  }
}

a.more {
  color: #999;
}

.divTab {
  background: #fff;
  padding: 20px;
}

.course {
  margin-bottom: 16px;
  position: relative;

  .qualified {
    position: absolute;
  }
}

.course-detail {
  color: #999;
  margin-bottom: 6px;

  .course-score {
    font-size: 18px;
    font-weight: bold;
    color: $bgColor;
  }

  span {
    color: #999 !important;
    a {
      color: #999 !important;
      font-size: 13px;
    }
  }
}

.buttons {
  margin-top: 4px;
}

.examinationtime {
  color: #999;
  font-size: 14 px;
}

.course-btn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: 92px;
  height: 30px;
  background: #ccd1cf;
  line-height: 30px;
  border-radius: 15px;
  color: #fff;
  border: none;
  margin-top: 12px;
  margin-bottom: 12px;

  &.active {
    background: $bgColor;
  }
}

.course-btn-large {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: 132px;
  height: 30px;
  background: #ccd1cf;
  line-height: 30px;
  border-radius: 15px;
  color: #fff;
  border: none;
  margin-top: 12px;
  margin-bottom: 12px;

  &.active {
    background: $bgColor;
  }
}

.examinationtime p {
  margin-bottom: 10px;
}

.tabs .tab {
  display: none;
}

.tabs .tab.active {
  display: block;
}

.nav-tab div {
  float: left;
  padding: 6px 12px;
  margin-right: 20px;

  &.active {
    background: $bgColor;
    color: #fff;
    border: 1px solid $bgColor;
  }
}

coursetab li {
  margin-top: 10px !important;

  .&.active {
    background: $bgColor;
    color: #fff;
    border: 1px solid $bgColor;
  }
}

.icon-jinji {
  color: #ff0c23 !important;
  margin-left: 10px;
}

.pointer {
  cursor: pointer;
}

.sort {
  font-weight: normal;
  font-size: 15px;
  margin-left: 10px;
  color: #212529;
  padding: 5px 0px;
  width: 164px;
  display: inline-block;
  text-align: center;
  border-radius: 2px;
  user-select: none;
  cursor: pointer;

  i {
    margin-right: 10px;
  }
}

.sort-active {
  background: $bgColor;
  color: #fff;
}

.course {
  margin-top: 10px;
}

.largrshow {
  font-weight: bold;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/CoursePlan.vue